import ActionRow from "../components/v2/ActionRow";
import ChoiceStack from "../components/v2/ChoiceStack";
import HelperLine from "../components/v2/HelperLine";
import PageTransition from "../components/v2/PageTransition";
import QuestionCounter from "../components/v2/QuestionCounter";
import QuestionLabel from "../components/v2/QuestionLabel";
import Wordmark from "../components/v2/Wordmark";
import "../components/v2/v2-question-surface.css";

export const SURFACE_12_LABEL = "How do they talk?";
export const SURFACE_12_HELPER = "Pick up to 4.";

export const SPEECH_STYLE_OPTIONS = [
  {
    key: "reserved",
    title: "Reserved",
    explanation: "picks their words, doesn't talk to fill silence",
  },
  {
    key: "direct",
    title: "Direct",
    explanation: "says what they mean, not a lot of softening",
  },
  {
    key: "warm",
    title: "Warm",
    explanation: "emotionally open, easy to talk to",
  },
  {
    key: "dry",
    title: "Dry",
    explanation: "deadpan delivery, sarcasm is a love language",
  },
  {
    key: "playful",
    title: "Playful",
    explanation: "quick to joke, keeps things light",
  },
  {
    key: "thoughtful",
    title: "Thoughtful",
    explanation: "pauses before answering, lands on the right word",
  },
  {
    key: "nerdy",
    title: "Nerdy",
    explanation: "gets into details, lights up about specifics",
  },
  {
    key: "salty",
    title: "Salty",
    explanation: "casual with language, doesn't dress things up",
  },
];

export default function Surface12({
  value = [],
  direction = "forward",
  onChange,
  onBack,
  onNext,
  editMode = false,
}) {
  const selectedValues = Array.isArray(value) ? value : [];

  return (
    <section className="tgc-v2-surface tgc-v2-surface--choice" aria-labelledby="question-label">
      <PageTransition direction={direction}>
        <div className="tgc-v2-choice-shell">
          <div className="tgc-v2-choice-header">
            <Wordmark variant="stacked" />
            <QuestionCounter current={8} total={12} />
            <QuestionLabel>{SURFACE_12_LABEL}</QuestionLabel>
            <HelperLine id="surface-12-helper">{SURFACE_12_HELPER}</HelperLine>
          </div>

          <div className="tgc-v2-choice-scroll" aria-describedby="surface-12-helper">
            <ChoiceStack
              options={SPEECH_STYLE_OPTIONS}
              value={selectedValues}
              behavior="multi-select"
              max={4}
              ariaLabel="Speech style options"
              onChange={onChange}
            />
          </div>

          <div className="tgc-v2-choice-back">
            <ActionRow
              variant={editMode ? "done-only" : "two-button"}
              onBack={onBack}
              onNext={onNext}
              nextDisabled={selectedValues.length === 0}
              nextLabel={editMode ? "Done" : "Next"}
            />
          </div>
        </div>
      </PageTransition>
    </section>
  );
}
